import { EntityListSchema, type Entity } from "@/types/Entity";

export const getAllEntities = async (): Promise<Entity[]> => {
  let entities: Entity[] = [];
  await axios
    .get("/entities")
    .then((response) => {
      entities = EntityListSchema.parse(response.data.result);
    })
    .catch((e) => errorApi(e));
  return entities;
};
